import { FiChevronRight } from "react-icons/fi";
import { DocumentLink } from "../common/DocumentLink";
import { LeagueTeamWithPlayers } from "../../models/LeagueTeam";
import { PlayerImage, TeamImage } from "../common/Images";
import { filterPlayersAndCoaches } from "@/helper/util";
import { NoItems } from "@/components/common/NoItems";
import { useTranslation } from "next-i18next";

interface TeamsListProps {
  teams: LeagueTeamWithPlayers[];
  baseUrl: string;
}
export function TeamsList({ teams, baseUrl }: TeamsListProps) {
  const { t } = useTranslation();
  if (teams.length === 0)
    return (
      <div className="container">
        <NoItems />
      </div>
    );
  return (
    <div className="container container-no-padding xl:rounded-md overflow-hidden">
      <div className="max-lg:hidden grid grid-cols-7 text-gray-text text-md mx-4 px-4">
        <div className="text-gray-text col-span-2">{t("Label_Team")}</div>
        <div className="text-gray-text ml-auto mr-12">{t("Form_Coach")}</div>
        <div className="text-gray-text col-span-4">{t("Player")}</div>
      </div>
      {teams.map((team) => (
        <TeamCard key={team.id} team={team} baseUrl={baseUrl} />
      ))}
    </div>
  );
}

interface TeamCardProps {
  team: LeagueTeamWithPlayers;
  baseUrl: string;
}
function TeamCard({ team, baseUrl }: TeamCardProps) {
  const { coaches, players } = filterPlayersAndCoaches(team.players);

  return (
    <DocumentLink
      href={`${baseUrl}/${team.seasonTeamId}`}
      className="bg-white flex items-center border-b border-gray-light group last:border-none py-4 lg:border-none lg:grid lg:grid-cols-7 lg:rounded-lg lg:bg-bg-gray p-4 lg:m-4"
    >
      <div className="flex items-center gap-4 col-span-2">
        <TeamImage team={team.seasonTeam} size="lg" />
        <div className="text-xl text-primary flex-1">
          {team.seasonTeam.name}
        </div>
      </div>
      <div className="flex items-center ml-auto gap-4 max-lg:hidden">
        {coaches.map((player) => (
          <PlayerImage key={player.id} player={player.seasonPlayer} />
        ))}
        {coaches.length > 0 && (
          <div className="w-[2px] h-10 ml-auto mr-4 rounded-full bg-gray-text" />
        )}
      </div>
      <div className="flex items-center gap-4 col-span-4 ml-auto lg:ml-0">
        <div className="flex items-center gap-4 max-lg:hidden">
          {players.slice(0, 8).map((player) => (
            <PlayerImage key={player.id} player={player.seasonPlayer} />
          ))}
        </div>
        <FiChevronRight
          size={24}
          className="group-hover:-translate-x-1 transition-transform duration-200 ml-auto mr-4"
        />
      </div>
    </DocumentLink>
  );
}
